var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldCollaboratorDropdown',{staticClass:"dropdown--floating filters__value-dropdown",attrs:{"collaborators":_vm.workspaceCollaborators,"disabled":_vm.disabled,"value":_vm.copy,"show-empty-value":false,"fixed-items":true,"initial-display-name":_vm.initialDisplayName},on:{"input":_vm.input}})
}
var staticRenderFns = []

export { render, staticRenderFns }